import React from 'react'
import './feature.css'
import { motion, useScroll, useTransform } from "framer-motion";
const Feature = ({ title, text }) => {

    const { scrollYProgress } = useScroll();
    let rightToCenter = useTransform(scrollYProgress, [0, .3], [0, 30]);
    let leftToCenter = useTransform(scrollYProgress, [0, .2], [0, 20]);

    return (
        <div className="gpt3__features-container__feature">
            <motion.div style={{ x: rightToCenter }} className="gpt3__features-container__feature-title">
                <div />
                <h1>{title}</h1>
            </motion.div>
            <motion.div style={{ x: leftToCenter }} className="gpt3__features-container_feature-text">
                <p>{text}</p>
            </motion.div>
        </div>
    )
}

export default Feature